import { SiteUrls } from '@tableau/shared-urls';
import { DataGrid } from '@tableau/widgets-datagrid';

import { ContentLineageRelationshipCell } from './ContentLineageRelationshipCell';
import { SelectFlowCell } from './SelectFlowCell';

export module LinkedTaskItemSelectorGrid {
  export function contentLineageRelationshipColumn(
    isSelected: (id: string) => boolean,
    onItemSelectionToggled: (row: DataGrid.Row) => void,
    siteUrls: SiteUrls,
  ): DataGrid.Column[] {

    const contentLineageRelationshipColumn: DataGrid.Column = {
      name: 'content-lineage-relationship-col',
      dataKey: 'contentLineageRelationship',
      sortable: false,
      growToFit: true,
      resizable: false,
      headerText: null,
      headerFormatter: null,
      cellFormatter: ContentLineageRelationshipCell(isSelected, onItemSelectionToggled, siteUrls),
    };

    return [contentLineageRelationshipColumn];
  }

  export function allFlowsColumn(
    isSelected: (id: string) => boolean,
    onItemSelectionToggled: (row: DataGrid.Row) => void,
    siteUrls: SiteUrls,
  ): DataGrid.Column[] {

    const allFlowsColumn: DataGrid.Column = {
      name: 'all-flows-col',
      dataKey: 'flow',
      sortable: false,
      growToFit: true,
      resizable: false,
      headerText: null,
      headerFormatter: null,
      cellFormatter: SelectFlowCell(isSelected, onItemSelectionToggled, siteUrls),
    };

    return [allFlowsColumn];
  }
}
